import { connect } from 'react-redux';
import { fetchActivateAccount } from '../../../../reducers/account/activation';
import ActivateEmployeeAccount from './ActivateEmployeeAccount';
import { getTranslation } from "../../../../reducers/common/localization";
import { showModal, MODAL_LICENSE_AGREEMENT } from "../../../../reducers/common/activeModal";
import { getUserPersonalData } from '../../../../reducers/account/userData';

const mapStateToProps = (state) => {
    return {
        data: getUserPersonalData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onActivate: (token, data) => {
            dispatch(fetchActivateAccount(token, data));
        },
        onShowLicenseAgreement : () => dispatch(showModal({modalKey: MODAL_LICENSE_AGREEMENT}))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivateEmployeeAccount);



// WEBPACK FOOTER //
// ./src/components/accountManagement/activateUserAccount/activateEmployeeAccount/ActivateEmployeeAccount.container.js